if (!customElements.get('buy-now-button')) {
  customElements.define(
    'buy-now-button',
    class BuyNowButton extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.spinner = this.querySelector('.loading__spinner');
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        if (!this.button) return;

        this.button.addEventListener('click', this.onClick);

        // Mirror the add-to-cart button's availability (Dawn toggles it on variant change).
        this.submitButton = this.form?.querySelector('[type="submit"].product-form__submit');
        if (this.submitButton) {
          this.syncDisabledState();
          this.observer = new MutationObserver(this.syncDisabledState.bind(this));
          this.observer.observe(this.submitButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
          });
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.observer?.disconnect();
      }

      syncDisabledState() {
        const disabled =
          this.submitButton.hasAttribute('disabled') || this.submitButton.getAttribute('aria-disabled') === 'true';
        this.button.toggleAttribute('disabled', disabled);
      }

      onClick(event) {
        event.preventDefault();

        if (!this.form || this.button.hasAttribute('disabled') || this.button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.productForm?.handleErrorMessage();
        this.toggleLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(this.form);

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.productForm?.handleErrorMessage(response.description || response.message);
              this.toggleLoading(false);
              return;
            }

            window.location.href = this.checkoutUrl;
          })
          .catch((error) => {
            console.error(error);
            this.productForm?.handleErrorMessage(window.cartStrings?.error);
            this.toggleLoading(false);
          });
      }

      toggleLoading(loading) {
        this.button.setAttribute('aria-disabled', loading);
        this.button.classList.toggle('loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
      }

      get form() {
        return this.closest('form') || document.getElementById(this.dataset.formId);
      }

      get productForm() {
        return this.closest('product-form');
      }

      get checkoutUrl() {
        const root = this.dataset.rootUrl || '/';
        return `${root.endsWith('/') ? root : `${root}/`}checkout`;
      }
    }
  );
}
